export default {
  LOAD_CYCLE_CASE_DIAGNOSIS_LIST_START: 'LoadCycleCaseDiagnosisListStart',
  LOAD_CYCLE_CASE_DIAGNOSIS_LIST_END: 'LoadCycleCaseDiagnosisListEnd',
  TOGGLE_CYCLE_CASE_DIAGNOSIS_LIST_CONFIRM_DIALOG: 'ToggleCycleCaseDiagnosisListConfirmDialog',
  OPEN_CYCLE_CASE_DIAGNOSIS_TLK_DIALOG: 'OpenCycleCaseDiagnosisTlkDialog',
  CLOSE_CYCLE_CASE_DIAGNOSIS_TLK_DIALOG: 'CloseCycleCaseDiagnosisTlkDialog'
};